/* DSL Delivery promise — toon "morgen geleverd" op basis van postcode + tijd */
(function(){
  var slot = document.querySelector("[data-delivery-promise]");
  if (!slot) return;
  var now = new Date();
  var hour = now.getHours();
  var dow = now.getDay();
  var sameDay = (dow >= 1 && dow <= 5 && hour < 16);
  var nextDay = (dow >= 1 && dow <= 5 && hour >= 16) || dow === 0;
  var msg;
  if (sameDay) msg = "📦 Bestel binnen <strong>" + (16 - hour) + " uur</strong> en ontvang het morgen (NL).";
  else if (nextDay) msg = "📦 Bestel nu — geleverd over 2 werkdagen (NL).";
  else msg = "📦 Bestel nu — eerstvolgende verzending op maandag (NL).";
  slot.innerHTML = msg;
  // Postcode-input refinement
  document.addEventListener("blur", function(e){
    if (!e.target.matches("[data-postcode-check]")) return;
    var pc = e.target.value.replace(/\s+/g, "").toUpperCase();
    if (!/^\d{4}[A-Z]{2}$/.test(pc)) return;
    // NL-only refinement
    slot.innerHTML += " <em>Voor postcode " + pc + ": geen extra info beschikbaar.</em>";
    if (window.DSL_AB) window.DSL_AB.track("delivery_promise_postcode", {pc: pc.slice(0,2)});
  }, true);
})();